import { reverse, ifElse, equals, always, concat } from 'ramda'
import { useState, useEffect } from 'react'
import { select, useSelect } from '@wordpress/data'


export const useSelectEvents = (props = {}) => {
    const {
        dateRange = {},
        initialValue = []
    } = props;
    const [events, setEvents] = useState(initialValue)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const selectEvents = ({ dateRange } = {}) => {
        try {
            setIsLoading(true)
            const newEvents = useSelect(select => {
                return select('core').getEntityRecords('postType', 'event')
            }, [dateRange])
            console.log({ newEvents })
            setEvents(newEvents)
            setIsLoading(false)
        } catch (error) {
            setError(error)
        }
    }

    useEffect(() => {
        selectEvents({ dateRange })
    }, [])
    return { events, selectEvents, error, isLoading }
}

export default useSelectEvents